// https://docsstyleguide.z13.web.core.windows.net/icon-font.html
import React from 'react';
import PropTypes from 'prop-types';

const DoconIcon = ({ name, size = 'default', className = '' }) => {
  return (
    <span
      className={`icon ${className} docon size-${size} docon-${name}`}
      aria-hidden="true"
    ></span>
  );
};

DoconIcon.propTypes = {
  className: PropTypes.string,
  size: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
};

DoconIcon.defaultProps = {
  className: '',
  size: '',
  name: '',
};

export default DoconIcon;
